import React from 'react';
import styled from '@emotion/styled';

const Spinner = () => <SpinnerContainer className="kt-spinner kt-spinner--lg kt-spinner--info" />;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  &:before {
    position: relative !important;
    margin: 0 !important;
  }
`;

export default Spinner;
